import * as pubsub from "pubsub-js";
import { BookmarkModel } from "client/Api/Documents/Bookmarks/bookmarks";

enum BookmarkEvent {
	// When 1 bookmark was created
	Added = "document.bookmarks.added",
	// When 1 or multiple bookmarks are deleted
	Deleted = "document.bookmarks.deleted",
	// When 1 bookmarks was renamed
	Renamed = "document.bookmarks.renamed",
}

type Data<T extends BookmarkEvent> =
	T extends BookmarkEvent.Added ? BookmarkModel :
	T extends BookmarkEvent.Deleted ? number[] :
	T extends BookmarkEvent.Renamed ? { id: number; newName: string; } :
	never;

export const subscribe: <T extends BookmarkEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends BookmarkEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	BookmarkEvent
};
